import cx from 'classnames'
import Route from 'route-parser'
import { Download as DownloadIcon } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
import { getBaseURI } from 'libraries/front-end-core/helpers/document'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { URL_DOCUMENT_DOWNLOAD } from 'constants/urls'
import { $user } from 'services/SessionService'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'
import selectUserAccessRoles from 'redux/selectors/selectAccessRoles'
import ResponseConsumer from 'components/shared/ResponseConsumer'
interface LinkProps extends DownloadLinkProps {
  isLogged: boolean
  accessRoles: string[]
}

function Link ({ id, isLogged, aol, accessRoles, selectable }: LinkProps): JSX.Element {
  const dispatch = useDispatch()
  const hasAccess = isLogged && accessRoles.includes('corporate_documents_premium')

  return (
    <a
      className={cx('w7 h2 bg-transparent pointer mh0-m', { mh8: selectable, mr6: !selectable })}
      href={
        hasAccess
          ? getBaseURI() + (new Route(URL_DOCUMENT_DOWNLOAD).reverse({ aol, id }) as string)
          : ''
        }
      onClick={() => {
        if (!isLogged) {
          return dispatch(setSignUpModalIsOpen(true))
        }
        if (isLogged && !hasAccess) {
          return dispatch(setUserRolesModalIsOpen(true))
        }
      }}
      {...(hasAccess
        ? {
            target: '_blank',
            rel: 'noopener noreferrer',
            'data-event-category': 'Documents',
            'data-event-action': 'Download',
            'data-event-label': `${id}`
          }
        : {})}
    >
      <DownloadIcon className='h-100 w-100 precedents-blue right3' />
    </a>
  )
}

interface DownloadLinkProps {
  aol: string
  id: string
  selectable: boolean
}

export default function DownloadLink (props: DownloadLinkProps): JSX.Element {
  const response = useObservable(
    $user,
    RESPONSE_PENDING
  )
  const accessRoles = useSelector(selectUserAccessRoles)

  return (
    <ResponseConsumer
      response={response}
      content={() => <Link {...props} isLogged accessRoles={accessRoles} />}
      unauthorizedComponent={() => <Link {...props} isLogged={false} accessRoles={[]} />}
    />
  )
}
